"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.sub");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _vueHtml2pdf = _interopRequireDefault(require("vue-html2pdf"));
var _courseDeclare = require("@/api/courseDeclare/courseDeclare");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      courseLeaderName1: '',
      jobNumber1: '',
      jin: false,
      dialogVideo: false,
      videoUrl: '',
      endTime: '',
      startTime: '',
      start: '',
      end: '',
      isIng: 1,
      dialogxia3: false,
      dialogxia2: false,
      showLayout: false,
      isDown: false,
      showDown: false,
      isDownBtn: 0,
      userInfo: {},
      declareType: '全部',
      declareOption2: [{
        name: '认定',
        value: '认定'
      }, {
        name: '建设',
        value: '建设'
      }],
      declareOption: [{
        name: "全部",
        value: "全部"
      }, {
        name: '认定',
        value: '认定'
      }, {
        name: '建设',
        value: '建设'
      }],
      teacherAll: [],
      addDeclareType: '',
      form: {
        matchId: this.$route.query.id,
        courseLeader: "",
        courseName: "",
        id: ''
      },
      rules: {
        // contactNumber: [
        //   { validator: validatePhoneTwo, trigger: "blur" }
        // ],
      },
      dialog: false,
      dialog2: false,
      dialog3: false,
      secondDetail: {
        courseHourList: [],
        courseTeamList: [],
        courseTeamOtherList: []
      },
      thirdDetail: {
        courseLeaderTeachingList: [],
        courseTeamList: [],
        courseEachLectureList: []
      },
      //附件2 for循环 左侧colspan值

      //附件3 for循环 左侧colspan值
      teachingList: 5,
      teamList: 2,
      lectureList: 2,
      num: 10,
      //
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "项目名称"
      }, {
        label: "推荐状态",
        type: "select",
        model: "tuijian",
        placeholder: "推荐状态",
        options: [{
          name: "待填写",
          value: 0
        }, {
          name: "已保存",
          value: 1
        }, {
          name: "学校审核",
          value: 2
        }, {
          name: "市审核",
          value: 4
        }, {
          name: "省审核",
          value: 6
        }]
      }],
      modelData: {
        queryValue: "",
        tuijian: ""
      },
      minWidth: 300,
      allPages: {
        matchId: this.$route.query.id,
        name: "",
        pageNum: 1,
        pageSize: 10,
        state: ""
      },
      page: {
        matchId: this.$route.query.id,
        name: '',
        state: '',
        pageNumber: 1,
        pageSize: 10
      },
      type: "",
      totalData: 0,
      listData: [],
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      searchName: "",
      checkBoxData: []
    };
  },
  computed: {
    htmlToPdfOptions: function htmlToPdfOptions() {
      return {
        margin: 0,
        filename: "附件.pdf",
        image: {
          type: "jpeg",
          quality: 0.98
        },
        enableLinks: true,
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: "in",
          format: 'a4',
          orientation: 'portrait'
        }
      };
    }
  },
  methods: {
    deleteCourse: function deleteCourse(e) {
      var _this = this;
      this.type = e.type;
      var idArr = [];
      idArr.push(e.id);
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        if (e.type === 1) {
          (0, _courseDeclare.deleteByIdSecond)({
            idList: idArr
          }).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success(res.msg);
              _this.getList();
            }
          });
        } else if (e.type === 2) {
          (0, _courseDeclare.deleteByIdThird)({
            idList: idArr
          }).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success(res.msg);
              _this.getList();
            }
          });
        }
      });
    },
    //学校修改课程 获取回显数据
    getFirstCourse: function getFirstCourse(e) {
      var _this2 = this;
      this.type = e.type;
      this.dialog = true;
      if (e.type === 1) {
        (0, _courseDeclare.getFirstCourseSecond)({
          id: e.id
        }).then(function (res) {
          var data = res.data;
          if (data.jobNumber) {
            data.courseLeader = data.courseLeader + '--工号：' + data.jobNumber;
          }
          _this2.form = data;
          _this2.addDeclareType = '认定';
          _this2.jin = true;
        });
      } else if (e.type === 2) {
        (0, _courseDeclare.getFirstCourseThird)({
          id: e.id
        }).then(function (res) {
          var data = res.data;
          if (data.jobNumber) {
            data.courseLeader = data.courseLeaderName + '--工号：' + data.jobNumber;
          }
          _this2.form = data;
          _this2.addDeclareType = '建设';
          _this2.jin = true;
          console.log('this.form00000', _this2.form);
        });
      }
    },
    closeVideo: function closeVideo() {
      this.dialogVideo = false;
      // console.log(this.$refs.skVideo,666)
      this.$refs.skVideo.pause();
      // this.$refs.videoPlayer.dispose(); //关闭弹窗视频暂停方法
      // this.$refs.videoPlayer.onPlayerPause();
    },
    lookVideo: function lookVideo() {
      if (this.thirdDetail.lectureVideo.fileName) {
        this.dialogVideo = true;
        // this.playerOptions['sources'][0]['src'] = this.thirdDetail.lectureVideo.ossOriUrl;
        // console.log(this.playerOptions['sources'][0]['src'])
      }
    },
    //判断时间是否过期
    judgeTime: function judgeTime() {
      var _this3 = this;
      (0, _courseDeclare.getMatchById)({
        id: this.page.matchId
      }).then(function (res) {
        if (res.code === 2000) {
          _this3.endTime = res.data.endTime;
          _this3.startTime = res.data.startTime;
          if (_this3.endTime) {
            var endTime0 = _this3.endTime.replace("/-/g", "/"); //时间转换
            //时间
            _this3.end = new Date(endTime0);
          }
          if (_this3.startTime) {
            var startTime0 = _this3.startTime.replace("/-/g", "/"); //时间转换
            //时间
            _this3.start = new Date(startTime0);
          }
          //现在时间
          var date2 = new Date();
          //判断时间是否过期
          _this3.start < date2 && date2 < _this3.end ? _this3.isIng = 1 : _this3.isIng = 0;
          console.log('this.isIng', _this3.isIng);
          console.log('this.start', _this3.startTime);
          console.log('this.endTime', _this3.endTime);
        }
      });
    },
    getDetailxia: function getDetailxia(e) {
      var _this4 = this;
      this.type = e.type;
      this.isDownBtn = 1;
      this.showDown = true;
      this.isDown = true;
      if (e.type === 1) {
        this.getDetailSecond(e.id);
        this.dialogxia2 = true;
        setTimeout(function () {
          // this.exportPdfHandler('dao2','江苏省职业教育精品在线开放课程验收认定申报书')
          _this4.$refs.html2Pdf.generatePdf();
          setTimeout(function () {
            _this4.isDown = false;
            _this4.dialogxia2 = false;
          }, 3000);
        }, 2000);
      } else if (e.type === 2) {
        this.getDetailThird(e.id);
        this.dialogxia3 = true;
        setTimeout(function () {
          // this.exportPdfHandler('dao2','江苏省职业教育精品在线开放课程验收认定申报书')
          _this4.$refs.html2Pdf2.generatePdf();
          setTimeout(function () {
            _this4.isDown = false;
            _this4.dialogxia3 = false;
          }, 3000);
        }, 2000);
      }
    },
    downPDF2: function downPDF2() {
      var _this5 = this;
      this.isDown = true;
      setTimeout(function () {
        // this.exportPdfHandler('dao2','江苏省职业教育精品在线开放课程验收认定申报书')
        _this5.$refs.html2Pdf.generatePdf();
        setTimeout(function () {
          _this5.isDown = false;
        }, 3000);
      }, 1000);
    },
    // downPDF2(){
    //   this.isDown = true
    //   setTimeout(()=>{
    //       this.exportPdfHandler('dao2','江苏省职业教育精品在线开放课程验收认定申报书')
    //       setTimeout(()=>{
    //          this.isDown = false
    //       },3000)
    //   },1000)
    // },
    downPDF3: function downPDF3() {
      var _this6 = this;
      this.isDown = true;
      setTimeout(function () {
        _this6.exportPdfHandler('dao3', '江苏省职业教育精品在线开放课程立项建设申报书');
        setTimeout(function () {
          _this6.isDown = false;
        }, 3000);
      }, 1000);
    },
    //批量选择时
    handleSelectionChange: function handleSelectionChange(val) {
      var _this7 = this;
      this.checkBoxData = [];
      val.forEach(function (item) {
        _this7.checkBoxData.push(item.id);
      });
    },
    //已选择的标签禁用状态tagList  tagGroups   tagsItem
    isdisabled: function isdisabled(row, index) {
      if (this.userInfo.roleType == 5) {
        if (row.state == 1 || row.state == 3) {
          return true;
        }
      }
      if (this.userInfo.roleType == 3) {
        if (row.state == 2 || row.state == 5) {
          return true;
        }
        if (row.schoolType == 2 && row.state == 7) {
          return true;
        }
      }
      if (this.userInfo.roleType == 2 && row.schoolType == 1) {
        if (row.state == 4 || row.state == 7) {
          return true;
        }
      }
      if (this.userInfo.roleType == 1 && row.state == 6) {
        return true;
      }
    },
    subReviewOnly: function subReviewOnly(e, result) {
      this.type = e.type;
      this.checkBoxData = [];
      var ids = [];
      ids.push(e.id);
      var re = result;
      this.subReview(ids, re);
    },
    subReviewBatch: function subReviewBatch(arr, result) {
      console.log('this.declareType', this.declareType);
      if (this.declareType === "全部") {
        this.$message.error('请先选择课程类型为认证或建设，再批量操作');
      } else if (arr.length > 0) {
        var ids = arr;
        var re = result;
        this.subReview(ids, re);
      } else {
        this.$message.error('请先选择需要批量操作的内容');
      }
    },
    //学校 市 省 1推荐 / 0退回 申报书
    subReview: function subReview(ids, result) {
      var _this8 = this;
      if (this.type === 1) {
        (0, _courseDeclare.schoolReviewSecond)({
          matchId: this.$route.query.id,
          ids: ids,
          result: result
        }).then(function (res) {
          if (res.code === 2000) {
            _this8.$message.success(res.msg);
            // this.declareType = '认定'
            _this8.getList();
          }
        });
      } else if (this.type === 2) {
        (0, _courseDeclare.schoolReviewThird)({
          matchId: this.$route.query.id,
          ids: ids,
          result: result
        }).then(function (res) {
          if (res.code === 2000) {
            _this8.$message.success(res.msg);
            // this.declareType = '建设'
            _this8.getList();
          }
        });
      }
    },
    //老师 向学校提交申报书
    subOnly: function subOnly(e) {
      var _this9 = this;
      this.type = e.type;
      this.checkBoxData = [];
      var ids = [];
      if (e.type === 1) {
        (0, _courseDeclare.getPreviewInfoByIdSecond)({
          id: e.id
        }).then(function (res) {
          var data = res.data;
          var isKong = 0;
          if (data.courseTeamList.length > 0) {
            for (var i in data.courseTeamList) {
              if (data.courseTeamList[i].unit === '' || data.courseTeamList[i].undertakeTasks === '' || data.courseTeamList[i].platformUserName === '' || data.courseTeamList[i].name === '' || data.courseTeamList[i].mobile === '' || data.courseTeamList[i].courseId === '' || data.courseTeamList[i].email === '' || data.courseTeamList[i].jobTitle === '') {
                isKong = 1;
                console.log('data.courseTeamList-isKong', isKong);
              }
            }
          }
          console.log('lll', data);
          if (data.website == null || data.unit == null || data.teachingSituation == null || data.professionalCode == null || data.politicsFile.fileName == null || data.onlinePlatformTime == null || data.contactNumber == null || data.courseApplication == null || data.courseAssessment == null || data.courseDataFile.fileName == null || data.courseDuration == null || data.courseIntroduction == null || data.courseLeader == null || data.courseLink == null || data.courseName == null || data.courseNature == null || data.courseObject == null || data.courseProjectNo == null || data.courseSchool == null || data.courseTeachingLanguage == null || data.courseType == null || data.createBy == null || data.curriculumConstructionPlan == null || data.declarationDate == null || data.degreeOpenness == null || data.learningFile.fileName == null || data.mainClassPlatform == null) {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else if (data.website == '' || data.unit == '' || data.teachingSituation == '' || data.professionalCode == '' || data.politicsFile.fileName == '' || data.onlinePlatformTime == '' || data.contactNumber == '' || data.courseApplication == '' || data.courseAssessment == '' || data.courseDataFile.fileName == '' || data.courseDuration == '' || data.courseIntroduction == '' || data.courseLeader == '' || data.courseLink == '' || data.courseName == '' || data.courseNature == '' || data.courseObject == '' || data.courseProjectNo == '' || data.courseSchool == '' || data.courseTeachingLanguage == '' || data.courseType == '' || data.createBy == '' || data.curriculumConstructionPlan == '' || data.declarationDate == '' || data.degreeOpenness == '' || data.learningFile.fileName == '' || data.mainClassPlatform == '') {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else if (data.courseTeamList.length == 0) {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else if (isKong) {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else {
            ids.push(e.id);
            _this9.sub(ids);
          }
        });
      } else if (e.type === 2) {
        (0, _courseDeclare.getPreviewInfoByIdThird)({
          id: e.id
        }).then(function (res) {
          var data = res.data;
          var isKong = 0;
          if (data.courseTeamList.length > 0) {
            for (var i in data.courseTeamList) {
              if (data.courseTeamList[i].technicalPosition === '' || data.courseTeamList[i].sex === '' || data.courseTeamList[i].name === '' || data.courseTeamList[i].major === '' || data.courseTeamList[i].birthday === '' || data.courseTeamList[i].jobContent === '') {
                isKong = 1;
                console.log('data.courseTeamList-isKong', isKong);
              }
            }
          }
          if (data.courseLeaderTeachingList.length > 0) {
            for (var _i in data.courseLeaderTeachingList) {
              if (data.courseLeaderTeachingList[_i].studentNumber === '' || data.courseLeaderTeachingList[_i].sessionNumber === '' || data.courseLeaderTeachingList[_i].courseType === '' || data.courseLeaderTeachingList[_i].classHour === '' || data.courseLeaderTeachingList[_i].courseName === '') {
                isKong = 1;
                console.log('data.courseLeaderTeachingList', isKong);
              }
            }
          }
          if (data.courseEachLectureList.length > 0) {
            for (var _i2 in data.courseEachLectureList) {
              if (data.courseEachLectureList[_i2].title === '' || data.courseEachLectureList[_i2].duration === '' || data.courseEachLectureList[_i2].lecturer === '') {
                isKong = 1;
                console.log('data.courseEachLectureList', isKong);
              }
            }
          }
          if (data.totalTime == null || data.totalHour == null || data.technicalPosition == null || data.teamStructure == null || data.teachingSituation == null || data.teachingResearch == null || data.sex == null || data.selfEvaluation == null || data.resourceReserve == null || data.projectCategory == null || data.professionalCode == null || data.positioningTarget == null || data.name == null || data.mobile == null || data.lectureVideo.fileName == null || data.email == null || data.education == null || data.department == null || data.declarationUnit == null || data.declarationDate == null || data.createBy == null || data.courseType == null || data.courseName == null || data.courseContent == null || data.constructionMeasures == null || data.constructionFoundation == null || data.birthday == null || data.academicDegree == null || data.academicResearch == null || data.address == null) {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else if (data.totalTime == '' || data.totalHour == '' || data.technicalPosition == '' || data.teamStructure == '' || data.teachingSituation == '' || data.teachingResearch == '' || data.sex == '' || data.selfEvaluation == '' || data.resourceReserve == '' || data.projectCategory == '' || data.professionalCode == '' || data.positioningTarget == '' || data.name == '' || data.mobile == '' || data.lectureVideo.fileName == '' || data.email == '' || data.education == '' || data.department == '' || data.declarationUnit == '' || data.declarationDate == '' || data.createBy == '' || data.courseType == '' || data.courseName == '' || data.courseContent == '' || data.constructionMeasures == '' || data.constructionFoundation == '' || data.birthday == '' || data.academicDegree == '' || data.academicResearch == '' || data.address == '') {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else if (data.courseTeamList.length == 0 || data.courseLeaderTeachingList.length == 0 || data.courseEachLectureList.length == 0) {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else if (isKong) {
            _this9.$message.error('您还有必填项没有填写，请填写完整再提交');
          } else {
            ids.push(e.id);
            _this9.sub(ids);
          }
        });
      }
    },
    subBatch: function subBatch(arr) {
      if (arr.length > 0) {
        var ids = arr;
        this.sub(ids);
      } else {
        this.$message.error('请先选择需要批量操作的内容');
      }
    },
    sub: function sub(ids) {
      var _this0 = this;
      if (this.type === 1) {
        (0, _courseDeclare.teacherSubmitSecond)({
          matchId: this.$route.query.id,
          idList: ids
        }).then(function (res) {
          if (res.code === 2000) {
            _this0.$message.success(res.msg);
            // this.declareType = '认定'
            _this0.getList();
          }
        });
      } else if (this.type === 2) {
        (0, _courseDeclare.teacherSubmitThird)({
          matchId: this.$route.query.id,
          idList: ids
        }).then(function (res) {
          if (res.code === 2000) {
            _this0.$message.success(res.msg);
            // this.declareType = '建设'
            _this0.getList();
          }
        });
      }
    },
    // 老师 填写申报书
    fillIn: function fillIn(e) {
      this.type = e.type;
      console.log('点了吗', e);
      console.log('this.declareType', this.declareType);
      if (e.type === 1) {
        this.$router.push({
          path: "/courseDeclare/acceptance",
          query: {
            id: e.id,
            schoolType: e.schoolType
          }
        });
      } else if (e.type === 2) {
        this.$router.push({
          path: "/courseDeclare/courseProEs",
          query: {
            id: e.id,
            schoolType: e.schoolType
          }
        });
      }
    },
    // 模糊搜索
    search: function search(v) {
      // console.log('ppp',v)
      this.page.name = v.queryValue;
      this.allPages.name = v.queryValue;
      this.page.state = v.tuijian;
      this.allPages.state = v.tuijian;
      this.getList();
    },
    changeType: function changeType(val) {
      console.log('ppppp', val);
      this.page.pageNumber = 1;
      this.allPages.pageNum = 1;
      this.declareType = val;
      if (val === '认定') {
        this.type = 1;
      } else if (val === '建设') {
        this.type = 2;
      }
      console.log('ppppp', this.type);
      this.getList();
    },
    addCourse: function addCourse() {
      this.addDeclareType = '';
      this.jin = false;
      this.dialog = true;
    },
    closePDF: function closePDF() {
      this.isDown = false;
      this.showDown = false;
    },
    close: function close() {
      this.dialog = false;
      this.form = {
        matchId: this.$route.query.id,
        courseLeader: "",
        courseName: ""
      };
    },
    // 学校 添加申报课程 提交
    submit: function submit(v) {
      var _this1 = this;
      if (this.addDeclareType == '') {
        this.$message.error('请先选择课程类别');
      } else if (this.form.courseName == '') {
        this.$message.error('请先填写课程名称');
      } else if (this.form.courseLeader == '') {
        this.$message.error('课程负责人不能为空');
      } else {
        if (this.form.id) {
          this.$refs[v].validate(function (valid) {
            if (valid) {
              if (_this1.addDeclareType == '认定') {
                (0, _courseDeclare.updateFirstCourseSecond)(_this1.form).then(function (res) {
                  if (res.code === 2000) {
                    _this1.$message.success(res.msg);
                    _this1.dialog = false;
                    _this1.form = {
                      matchId: _this1.$route.query.id,
                      courseLeader: "",
                      courseName: "",
                      id: ""
                    }, _this1.getList();
                    console.log('this.addDeclareType', _this1.addDeclareType);
                  }
                });
              } else if (_this1.addDeclareType == '建设') {
                console.log('this.form', _this1.form);
                console.log('this.form.courseLeader', _this1.form.courseLeader);
                for (var i in _this1.teacherAll) {
                  if (_this1.form.courseLeader === _this1.teacherAll[i].courseLeader) {
                    _this1.form.courseLeader = _this1.teacherAll[i].id;
                  }
                }
                console.log('this.form.courseLeader', _this1.form.courseLeader);
                (0, _courseDeclare.updateFirstCourseThird)(_this1.form).then(function (res) {
                  if (res.code === 2000) {
                    _this1.$message.success(res.msg);
                    _this1.dialog = false;
                    _this1.form = {
                      matchId: _this1.$route.query.id,
                      courseLeader: "",
                      courseName: "",
                      id: ""
                    };
                    _this1.getList();
                    console.log('this.addDeclareType', _this1.addDeclareType);
                  }
                });
              }
            }
          });
        } else {
          this.$refs[v].validate(function (valid) {
            if (valid) {
              if (_this1.addDeclareType == '认定') {
                (0, _courseDeclare.insertFirstCourseSecond)(_this1.form).then(function (res) {
                  if (res.code === 2000) {
                    _this1.$message.success(res.msg);
                    _this1.dialog = false;
                    _this1.form = {
                      matchId: _this1.$route.query.id,
                      courseLeader: "",
                      courseName: "",
                      id: ""
                    }, _this1.getList();
                  }
                });
              } else if (_this1.addDeclareType == '建设') {
                (0, _courseDeclare.insertFirstCourseThird)(_this1.form).then(function (res) {
                  if (res.code === 2000) {
                    _this1.$message.success(res.msg);
                    _this1.dialog = false;
                    _this1.form = {
                      matchId: _this1.$route.query.id,
                      courseLeader: "",
                      courseName: "",
                      id: ""
                    };
                    _this1.getList();
                  }
                });
              }
            }
          });
        }
      }
    },
    //获取课程负责人列表
    getTeacherAll: function getTeacherAll() {
      var _this10 = this;
      (0, _courseDeclare.teacherAllList)({
        businessId: ''
      }).then(function (res) {
        var data = res.data;
        for (var i in data) {
          if (data[i].jobNumber) {
            data[i].courseLeader = data[i].courseLeader + '--工号：' + data[i].jobNumber;
          }
        }
        _this10.teacherAll = data;
        console.log('this.teacherAll', _this10.teacherAll);
      });
    },
    getDetail: function getDetail(e, i) {
      this.type = e.type;
      this.isDownBtn = i;
      if (e.state >= 6) {
        this.showDown = true;
      }
      if (e.type === 1) {
        this.getDetailSecond(e.id);
        this.dialog2 = true;
      } else if (e.type === 2) {
        this.getDetailThird(e.id);
        this.dialog3 = true;
      }
    },
    // 附件二 验收认定申报 根据id获取申报详情
    getDetailSecond: function getDetailSecond(id) {
      var _this11 = this;
      (0, _courseDeclare.getPreviewInfoByIdSecond)({
        id: id
      }).then(function (res) {
        var data = res.data;
        _this11.secondDetail = data;
        // this.dialog2 = true
      });
    },
    // 附件三 立项建设申报书 根据id获取申报详情
    getDetailThird: function getDetailThird(id) {
      var _this12 = this;
      (0, _courseDeclare.getPreviewInfoByIdThird)({
        id: id
      }).then(function (res) {
        var data = res.data;
        _this12.thirdDetail = data;
        // this.dialog3 = true

        _this12.thirdDetail.courseLeaderTeachingList.length ? _this12.teachingList = 4 + _this12.thirdDetail.courseLeaderTeachingList.length : _this12.teachingList = 5;
        _this12.thirdDetail.courseTeamList.length >= 5 ? _this12.teamList = 1 + _this12.thirdDetail.courseTeamList.length : _this12.teamList = 6 + _this12.thirdDetail.courseTeamList.length;
        _this12.thirdDetail.courseEachLectureList.length >= 5 ? _this12.lectureList = 1 + _this12.thirdDetail.courseEachLectureList.length : _this12.lectureList = 6 + _this12.thirdDetail.courseEachLectureList.length;
      });
    },
    // 获取申报列表 分页查询
    getList: function getList() {
      var _this13 = this;
      if (this.declareType === "全部") {
        (0, _courseDeclare.getAllList)(this.allPages).then(function (res) {
          var data = res.data;
          _this13.listData = data.list;
          _this13.listData.forEach(function (item) {
            _this13.type = item.type;
            // console.log('xuxuxuxuxxu',this.type);
          });
          // console.log('xxxxxxx', this.listData.type);
          _this13.totalData = data.total;
        });
      } else if (this.declareType === '认定') {
        (0, _courseDeclare.getSecondList)(this.page).then(function (res) {
          var data = res.data;
          _this13.listData = data.list;
          _this13.totalData = data.total;
        });
      } else if (this.declareType === '建设') {
        (0, _courseDeclare.getThirdList)(this.page).then(function (res) {
          var data = res.data;
          _this13.listData = data.list;
          _this13.totalData = data.total;
        });
      }
    },
    // 新增
    // save() {
    //   if (this.prCode === "guizhou") {
    //     this.$router.push("/object/objectGZ-add");
    //   } else {
    //     this.$router.push("/object/object-add");
    //   }
    // },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.allPages.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.allPages.pageSize = e;
      this.page.pageNumber = 1;
      this.allPages.pageNum = 1;
      this.getList();
    }
  },
  created: function created() {
    this.userInfo = this.$store.state.user.userInfo;
    this.getList();
    this.getTeacherAll();
    this.judgeTime();

    // console.log('userInfo',userInfo)
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    VueHtml2pdf: _vueHtml2pdf.default
  }
};